<template>

   <div id="home">
     <img class="rightElement" alt="element" src="../assets/images/home/homeBackgroundRight.png"/>
     <img class="leftElement" alt="rombo" src="../assets/images/home/homeBackgroundLeft.png"/>
    <select-lang></select-lang>
    <div class="flex-container" v-on:scroll="scrollToEnd" @wheel="scrollToEnd" @keydown.enter="scrollToEnd">
      <section>
        <!--img class="imgEsquina d-none d-md-block" src="../assets/images/home/apokEslogan.png"/-->
        <div class="row">
          <rombo id="rombo-portafolio" color="#60bdc5" class="d-none d-md-block">
          </rombo>
          <rombo id="rombo-servicio" class="rombo-menu"  v-on:click.native="$router.push({name: 'Services'})" rotate>
            <a class="box-link" v-on:click="$router.push({name: 'Services'})" v-html="$t('home.services')" :title="$t('home.services')"></a>
          </rombo>
          <rombo id="rombo-back" color="#F18800" class="d-none d-md-block"></rombo>
          <rombo id="rombo-back2" color="#F18800" class="d-none d-md-block"></rombo>
            <rombo id="rombo-padre" shadow>
              <img src="../assets/images/home/logo.png" width="500" class="logo" :title="$t('general.slogan')" :alt="$t('general.slogan')"/>
            </rombo>
        </div>

        <div class="row">
          <rombo id="rombo-contacto" class="rombo-menu"  v-on:click.native="$router.push({name: 'Contact'})" rotate>
            <a class="box-link" v-on:click="$router.push({name: 'Contact'})" v-html="$t('home.contact')" ></a>
          </rombo>
          <rombo id="rombo-nosotros" class="rombo-menu"  v-on:click.native="$router.push({name: 'AboutUs'})" rotate>
            <a class="box-link" v-on:click="$router.push({name: 'AboutUs'})" v-html="$t('home.about_us')" :title="$t('home.about_us')"></a>
          </rombo>
        </div>

        <div class="row">
          <rombo id="rombo-blog" class="rombo-menu"  rotate>
            <a class="box-link" v-html="$t('home.blog')" href="https://blog.grupoapok.com/" target="_blank"></a>
          </rombo>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
  /* eslint-disable  */
  import SelectLang from '../components/SelectLang'
  import Rombo from '../components/Rombo'
  import LayoutContent from '../components/layouts/LayoutContent'

  export default {
    components: {SelectLang, Rombo, LayoutContent},
    name: 'home',
    data () {
      return {
        textOver: 0
      }
    },
    methods: {
      scrollToEnd: function (event) {
        if (event.type === 'wheel') {
          if (event.deltaY > 0) {
            this.$router.push({name: 'Content'})
          }
        }
        else {
          if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            this.$router.push({name: 'Content'})
          }
          return window.scrollY > 100
        }
      },
      created () {
        window.addEventListener('scroll', this.scrollToEnd)
      },
      destroyed () {
        window.removeEventListener('scroll', this.scrollToEnd)
      }
    },
    created() {
      window.addEventListener('keydown', this.scrollToEnd)
    },
    destroyed() {
      window.removeEventListener('keydown', this.scrollToEnd)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only @import '../assets/styles/home.scss'; -->
<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/home.scss';

</style>




// WEBPACK FOOTER //
// src/pages/Home.vue